
import {dataNewlineProc, dataSingleNewlineProc, converDataNa} from '../Common/util';
// Result 목록
export const resultColumnData = [
    {
        title: '자산코드',
        dataIndex: 'asset_cd',
        key: 'asset_cd',
        width: '70px',
        align: 'center',
        ellipsis : false,
        fixed : true,
        className: 'fix_col',
        sorter: {
            compare: (a, b) => a.asset_cd.localeCompare(b.asset_cd),
            // compare: (a, b) => a.asset_cd - b.asset_cd,
        },
    },
    {
        title: '자산명',
        dataIndex: 'asset_nm',
        key: 'asset_nm',
        width: '150px',
        align: 'center',
        ellipsis : false,
        fixed : true,
        className: 'fix_col',
        sorter: {
            compare: (a, b) => a.asset_cd.localeCompare(b.asset_cd),
            // compare: (a, b) => a.asset_cd - b.asset_cd,
        },
    },
    {
        title: '진단코드',
        dataIndex: 'measure_cd',
        key: 'measure_cd',
        width: '70px',
        align: 'center',
        ellipsis : false,
        fixed : true,
        className: 'fix_col',
        sorter: {
            compare: (a, b) => a.measure_cd.localeCompare(b.measure_cd),
        },
    },
    {
        title: '진단명',
        dataIndex: 'measure_nm',
        key: 'measure_nm',
        width: '150px',
        align: 'center',
        ellipsis : false,
    },
    {
        title: '결과',
        dataIndex: 'result_cd',
        key: 'result_cd',
        width: '50px',
        align: 'center',
        editable: true,
    },
    {
        title: '현황',
        dataIndex: 'result_desc',
        key: 'result_desc',
        width: '500px',
        ellipsis : false,
        align: 'center',
        editable: true, 
        render: (value) => (
            <div style={{ 
                width: '100%',
                height: '100%',
                display: 'flex'
            }}>
                <div style={{ 
                    flex: 1,
                    maxHeight: '200px', 
                    overflowY: 'auto',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    textAlign: 'left',
                    padding: '8px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '2px',
                    backgroundColor: '#fff'
                }}>
                    {dataSingleNewlineProc(value)}
                </div>
            </div>
        ),
        onCell: () => ({
            style: {
                padding: '8px'
            }
        }),
    },
    {
        title: '위험도',
        dataIndex: 'risk_score',
        key: 'risk_score',
        width: '50px',
        align: 'center',
        className: 'fix_col',
        render: (value) => converDataNa(value),
    },
    {
        title: '중요도',
        dataIndex: 'total_score',
        key: 'total_score',
        width: '50px',
        align: 'center',
        className: 'fix_col',
    },
    {
        title: '평가',
        dataIndex: 'eval_score',
        key: 'eval_score',
        width: '50px',
        align: 'center',
        className: 'fix_col',
    },
    {
        title: '비고(수정내용)',
        dataIndex: 'remark',
        key: 'remark',
        width: '98px',
        ellipsis : false,
        align: 'center',
        editable: true,
    },
];

